import { render, staticRenderFns } from "./FiltersCard.vue?vue&type=template&id=2f7e8678&scoped=true&"
import script from "./FiltersCard.vue?vue&type=script&lang=js&"
export * from "./FiltersCard.vue?vue&type=script&lang=js&"
import style0 from "./FiltersCard.vue?vue&type=style&index=0&id=2f7e8678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e8678",
  null
  
)

export default component.exports